/**
 * Responsibility: Implement action resolution behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
export interface ResolutionMechanicsCheck {
  dc: number
}

function normalizeSuccessLevel(value: number): number {
  if (!Number.isFinite(value)) return 0
  if (value <= 0) return 0
  if (value >= 2) return 2
  return 1
}

/**
 * Reconciles AI-provided successLevel with a deterministic D20 check shown to the user.
 *
 * If a roll check is displayed in UI, the check outcome is authoritative for pass/fail.
 * We keep the AI level granularity (partial/full) only within the same pass/fail bucket.
 */
export function reconcileSuccessLevelWithCheck(
  successLevel: number,
  rollTotal: number,
  mechanics?: ResolutionMechanicsCheck | null,
): number {
  const normalized = normalizeSuccessLevel(successLevel)
  if (!mechanics || !Number.isFinite(mechanics.dc)) return normalized

  const passed = Number.isFinite(rollTotal) && rollTotal >= mechanics.dc
  if (passed && normalized <= 0) return 1
  if (!passed && normalized > 0) return 0
  return normalized
}
